// src/pages/admin/AdminListPage.js
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore'
import { db } from '../../firebaseConfig'

export default function AdminListPage() {
  const [admins, setAdmins] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDocs(collection(db, 'admins'))
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        // sort: super_admin first
        list.sort((a, b) => (a.role === 'super_admin' ? -1 : 1))
        setAdmins(list)
      } catch (err) {
        console.error('Load admins error', err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  const toggleActive = async (admin) => {
    if (
      !window.confirm(
        `${admin.name} akan di${admin.isActive ? 'nonaktifkan' : 'aktifkan'}?`
      )
    )
      return
    try {
      await updateDoc(doc(db, 'admins', admin.id), {
        isActive: !admin.isActive,
      })
      setAdmins((prev) =>
        prev.map((p) =>
          p.id === admin.id ? { ...p, isActive: !p.isActive } : p
        )
      )
      alert('Status diupdate')
    } catch (err) {
      console.error(err)
      alert('Gagal update status')
    }
  }

  const removeAdmin = async (admin) => {
    if (
      !window.confirm(`Hapus admin ${admin.name}? (tidak menghapus akun Auth)`)
    )
      return
    try {
      await deleteDoc(doc(db, 'admins', admin.id))
      setAdmins((prev) => prev.filter((p) => p.id !== admin.id))
      alert('Admin dihapus dari koleksi')
    } catch (err) {
      console.error(err)
      alert('Gagal menghapus admin')
    }
  }

  // Trigger Cloud Function (optional) — endpoint should be deployed separately
  const triggerCreateAuth = async (admin) => {
    if (!admin.isPending) {
      alert('Admin sudah memiliki Auth user.')
      return
    }

    if (!window.confirm(`Buatkan akun Auth untuk ${admin.email}?`)) return

    try {
      const res = await fetch(
        'https://asia-southeast2-aplikasi-pemesanan-jasa.cloudfunctions.net/createAdminUser',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            uid: admin.id,
            email: admin.email,
            name: admin.name,
            role: admin.role,
          }),
        }
      )

      const data = await res.json()

      if (!res.ok) {
        console.error(data)
        alert('Cloud Function error: ' + (data.error || data.message))
        return
      }

      // 🎉 PASSWORD BARU
      const tempPw = data.tempPassword || '(password tidak diterima)'

      alert(
        `✅ Admin berhasil dibuat!\n\n` +
          `Email: ${admin.email}\n` +
          `Password: ${tempPw}\n\n` +
          `Mohon simpan password ini untuk login pertama.`
      )

      window.location.reload()
    } catch (err) {
      console.error(err)
      alert('Gagal panggil Cloud Function')
    }
  }

  if (loading)
    return React.createElement(
      'div',
      { className: 'p-5 text-white' },
      'Loading admins...'
    )

  return React.createElement('div', { className: 'p-5 text-white space-y-4' }, [
    React.createElement(
      'div',
      { key: 'head', className: 'flex justify-between items-center' },
      [
        React.createElement(
          'h1',
          { key: 'title', className: 'text-2xl font-bold' },
          'Admin Management'
        ),
        React.createElement('div', { key: 'btns', className: 'flex gap-2' }, [
          React.createElement(
            'button',
            {
              key: 'add',
              className: 'px-3 py-2 bg-blue-600 rounded',
              onClick: () => navigate('/admin-management/add'),
            },
            'Add Admin'
          ),
          React.createElement(
            'button',
            {
              key: 'roles',
              className: 'px-3 py-2 bg-gray-700 rounded',
              onClick: () => navigate('/admin-management/roles'),
            },
            'Manage Roles'
          ),
        ]),
      ]
    ),

    React.createElement(
      'div',
      {
        key: 'table-wrap',
        className: 'border border-gray-700 rounded overflow-x-auto',
      },
      React.createElement('table', { className: 'w-full text-left text-sm' }, [
        React.createElement(
          'thead',
          { key: 'thead', className: 'bg-gray-800 text-gray-300' },
          React.createElement(
            'tr',
            null,
            ['Name', 'Email', 'Role', 'Active', 'Pending', 'Action'].map(
              (t, i) =>
                React.createElement(
                  'th',
                  { key: i, className: 'p-3 border-b border-gray-700' },
                  t
                )
            )
          )
        ),
        React.createElement(
          'tbody',
          { key: 'tbody' },
          admins.map((a) =>
            React.createElement(
              'tr',
              { key: a.id, className: 'hover:bg-gray-800' },
              [
                React.createElement(
                  'td',
                  { key: 'name', className: 'p-3 border-b border-gray-700' },
                  a.name
                ),
                React.createElement(
                  'td',
                  { key: 'email', className: 'p-3 border-b border-gray-700' },
                  a.email
                ),
                React.createElement(
                  'td',
                  { key: 'role', className: 'p-3 border-b border-gray-700' },
                  a.role
                ),
                React.createElement(
                  'td',
                  { key: 'active', className: 'p-3 border-b border-gray-700' },
                  a.isActive ? 'Yes' : 'No'
                ),
                React.createElement(
                  'td',
                  { key: 'pending', className: 'p-3 border-b border-gray-700' },
                  a.isPending ? 'Yes' : 'No'
                ),
                React.createElement(
                  'td',
                  {
                    key: 'act',
                    className: 'p-3 border-b border-gray-700 space-x-2',
                  },
                  [
                    React.createElement(
                      'button',
                      {
                        key: 'edit',
                        className: 'px-2 py-1 bg-yellow-500 rounded mr-1',
                        onClick: () =>
                          navigate(`/admin-management/roles/${a.role}`),
                      },
                      'Edit Role'
                    ),
                    React.createElement(
                      'button',
                      {
                        key: 'toggle',
                        className: 'px-2 py-1 bg-indigo-600 rounded mr-1',
                        onClick: () => toggleActive(a),
                      },
                      a.isActive ? 'Disable' : 'Enable'
                    ),
                    a.isPending &&
                      React.createElement(
                        'button',
                        {
                          key: 'create-auth',
                          className: 'px-2 py-1 bg-green-600 rounded mr-1',
                          onClick: () => triggerCreateAuth(a),
                        },
                        'Create Auth'
                      ),
                    React.createElement(
                      'button',
                      {
                        key: 'remove',
                        className: 'px-2 py-1 bg-red-600 rounded',
                        onClick: () => removeAdmin(a),
                      },
                      'Remove'
                    ),
                  ]
                ),
              ]
            )
          )
        ),
      ])
    ),
  ])
}
